import { render, staticRenderFns } from "./DescriptionAssuranceVie.vue?vue&type=template&id=bae5b758&scoped=true"
import script from "./DescriptionAssuranceVie.vue?vue&type=script&lang=js"
export * from "./DescriptionAssuranceVie.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAssuranceVie.vue?vue&type=style&index=0&id=bae5b758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae5b758",
  null
  
)

export default component.exports